import React, { useEffect, useState } from 'react';
import { BsTrash } from 'react-icons/bs';
import { TopicBookmark, TopicStyles } from '../mixins/mixins';

export const DefaultBookmarkItem = ({
	item,
	index,
	style,
	setStyle,
	setIsValid
}: {
	item: TopicBookmark;
	index: number;

	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
	setIsValid: (isValid: boolean) => void;
}) => {
	const [error, setError] = useState('');

	const removeBookmarks = () => {
		if (style.defaultBookmarkList) {
			const updatedBookmarks: TopicBookmark[] =
				style.defaultBookmarkList.slice();
			updatedBookmarks.splice(index, 1);
			setStyle({ ...style, defaultBookmarkList: updatedBookmarks });
		}
	};

	useEffect(() => {
		setIsValid(error == '');
	}, [error]);

	return (
		<>
			<div className="flex flex-row px-3">
				<div className="grid grid-cols-1 lg:grid-cols-2 justify-items-center w-5/6">
					<BookmarkInupt
						key={'bookmarkName' + item.url + index + '2'}
						styleKey={'name'}
						name={'Name'}
						placeholder={'Example'}
						optionState={item.name}
						item={item}
						index={index}
						style={style}
						setStyle={setStyle}
					/>

					<BookmarkInupt
						key={'bookmarkName' + item.url + index + '1'}
						styleKey={'url'}
						name={'URL'}
						placeholder={'www.example.com'}
						optionState={item.url}
						item={item}
						index={index}
						style={style}
						setStyle={setStyle}
						error={error}
						setError={setError}
					/>
				</div>

				{style.defaultBookmarkList != null && (
					<div className=" mt-auto ml-auto w-2/12">
						<div
							className="lg:ml-16 flex justify-center items-center h-12 w-12 text-gray-800 dark:text-white
									hover:text-white hover:bg-red-400 transition-all duration-500 ease-linear 
									hover:rounded-xl rounded-3xl cursor-pointer hover:shadow-lg"
							onClick={() => removeBookmarks()}
						>
							<BsTrash size="22" />
						</div>
					</div>
				)}
			</div>
			<div className="mx-auto border-t w-9/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />
		</>
	);
};

function isValidURL(string: string) {
	const res = string.match(
		/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)/g
	);
	return res !== null;
}

type BookmarkInuptProps = {
	styleKey: string;
	name: string;
	placeholder: string;

	item: TopicBookmark;
	index: number;
	optionState: string | undefined;

	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
	error?: string;
	setError?: (error: string) => void;
};
const BookmarkInupt = ({
	styleKey,
	name,
	placeholder,
	item,
	index,
	optionState,
	style,
	setStyle,
	error,
	setError
}: BookmarkInuptProps) => {
	const [value, setValue] = useState(optionState);

	useEffect(() => {
		item = { ...item, [styleKey]: value };
		let updatedBookmarkList: TopicBookmark[] = [];
		if (style.defaultBookmarkList != null)
			updatedBookmarkList = style.defaultBookmarkList.slice();
		updatedBookmarkList[index] = {
			name: item.name,
			url: item.url
		};

		if (setError != null)
			if (!isValidURL(item.url)) setError('Url is not valid');
			else setError('');

		setStyle({ ...style, defaultBookmarkList: updatedBookmarkList });
	}, [value]);

	return (
		<div className="w-8/12">
			<h3 className="block mb-2 text-sm font-medium text-gray-800 dark:text-gray-300">
				{name}
			</h3>
			<input
				type="text"
				id="name"
				className="bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
				placeholder={placeholder}
				required
				defaultValue={value}
				onBlur={(e: any) => {
					setValue(e.target.value);
				}}
			/>
			{error != '' ? (
				<p className="text-red-500 text-xs italic text-right ml-auto h-4">
					{error}
				</p>
			) : (
				<div className="mb-4" />
			)}
		</div>
	);
};
